export default __webpack_public_path__ + "static/media/rid-01@2x.36d75a67.jpg";